import React from 'react';

import { connect } from 'react-redux';

import { selectLocale } from 'wanderu-i18n';

import GetTheApp from '../../components/GetTheApp/GetTheApp';

function GetTheAppConainer(props) {
    const {
        staticContext,
    } = props;

    if (staticContext) {
        staticContext.cache = {
            secondsFromNow: 60 * 60 * 24 * 7,
        };
    }

    return (
        <GetTheApp {...props} />
    );
}

function mapStateToProps(appState) {
    return {
        locale: selectLocale(appState),
    };
}

export {
    GetTheAppConainer,
    mapStateToProps,
};
export default connect(mapStateToProps)(GetTheAppConainer);
